<template>
	<div id="footer">

		<div class="footer_top">
			<div class="footer_top_list">
				<img src="./../assets/img/foot1.png" alt="" />
				<div class="footer_top_list_info">
					<div>多元服务</div>
					<span>社保托管、税务代办、财务规划、知识产权和资质代办等</span>
				</div>
			</div>
			<div class="footer_top_list">
				<img src="./../assets/img/foot2.png" alt="" />
				<div class="footer_top_list_info">
					<div>数据安全</div>
					<span>自动化备份，关键数据加密，确保用户数据安全</span>
				</div>
			</div>
			<div class="footer_top_list">
				<img src="./../assets/img/foot3.png" alt="" />
				<div class="footer_top_list_info">
					<div>专业之长</div>
					<span>3年以上从业经验人员，集知产会计代账专业之长</span>
				</div>
			</div>
			<div class="footer_top_list">
				<img src="./../assets/img/foot4.png" alt="" />
				<div class="footer_top_list_info">
					<div>品质保证</div>
					<span>多年以上财税经验积累，流程规范，严格按合同执行</span>
				</div>
			</div>
		</div>
		<div class="company">
			<div class="info">
				<h5>工商服务</h5>
				<div>
					公司减资
				</div>
				<div>
					工商年报
				</div>
				<div>
					公司注销
				</div>
				<div>
					公司变更
				</div>
				<div>
					公司注册
				</div>
			</div>
			<div class="info">
				<h5>资质代办</h5>
				<div>
					食品经营许可证
				</div>
				<div>
					ICP经营许可证
				</div>
				<div>
					EDI经营许可证
				</div>
				<div>
					高新技术企业
				</div>
				<div>
					经营账外包
				</div>
			</div>
			<div class="info">
				<h5>数字化</h5>
				<div>
					SSL证书
				</div>
				<div>
					云服务器
				</div>
				<div>
					小程序开发
				</div>
				<div>
					企业网站定制
				</div>
				<div>
					商城系统
				</div>
			</div>

			<div class="info">
				<h5>知识产权</h5>
				<div>
					商标转让
				</div>
				<div>
					商标变更
				</div>
				<div>
					商标续展
				</div>
				<div>
					版权登记
				</div>
				<div>
					商标注册
				</div>
			</div>




			<div class="gzg_info">
				<p>关注企服</p>
				<div>
					<div>关于我们</div>
					<div>联系我们</div>
					<img src="@/assets/img/gzh.png" alt="" />
					<div>联系电话：{{info.serverPhone}}</div>
				</div>

			</div>

			<div class="info4">
				<div class="info_list">
					<van-collapse :boder="boderD" v-model="activeName" accordion class="ninini">
						<van-collapse-item :boder="boderD" title="工商服务" name="1">
							<div>
								公司减资
							</div>
							<div>
								工商年报
							</div>
							<div>
								公司注销
							</div>
							<div>
								公司变更
							</div>
							<div>
								公司注册
							</div>
						</van-collapse-item>
						<van-collapse-item :boder="boderD" title="资质代办" name="2">
							<div>
								食品经营许可证
							</div>
							<div>
								ICP经营许可证
							</div>
							<div>
								EDI经营许可证
							</div>
							<div>
								高新技术企业
							</div>
							<div>
								经营账外包
							</div>
						</van-collapse-item>
						<van-collapse-item :boder="boderD" title="联系我们" name="3">
							<div>
								客服电话：{{info.serverPhone}}
							</div>
						</van-collapse-item>
					</van-collapse>
				</div>
			</div>
		</div>
		<div class="record">
			<div>
				<span>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index"
						target="_blank">{{info.icp}}</a><span>{{info.own}}</span>
				</span>
			</div>

		</div>
	</div>
</template>
<script>
	import secretKey from '../../common/secretKey.js'
	import axios from 'axios'
	export default {
		name: "Footer",
		data() {
			return {
				from: {
					token: '',
				},
				boderD: false,
				activeName: '',
				info: '',
				domain: '',
			};
		},
		mounted() {
			// 如果需要包含协议，可以这样组合
			this.domain = `${window.location.protocol}//${window.location.hostname}`;
			this.getInfo()
		},
		methods: {
			getInfo() {
				this.from.token = secretKey.generateRandomAlphaString(10)
				this.$delete(this.from, "signature")
				let newKsort = secretKey.ksort(this.from)
				let newData = secretKey.objectToQueryString(newKsort)
				let sha1 = secretKey.sha1(newData)
				let newSD = secretKey.generateSignature(sha1)
				this.from.signature = newSD
				// 发起 POST 请求
				axios.post('/login/service', this.from)
					.then(response => {
						// console.log('响应数据:', response.data);
						this.info = response.data.data
					})
					.catch(error => {
						console.error('请求出错:', error);
					});
			},
		}
	};
</script>
<style>
	/* 消除折叠面板项的外层边框 */
	::v-deep .van-collapse-item {
		border: none !important;
	}

	/* 消除面板头部的下边框（展开/收起时的分隔线） */
	::v-deep .van-collapse-item__header {
		border-bottom: none !important;
	}

	/* 消除面板内容区的边框（若有） */
	::v-deep .van-collapse-item__content {
		border: none !important;
	}

	/* 可选：消除折叠面板容器的整体边框（如需） */
	::v-deep .van-collapse {
		border: none !important;
	}

	.van-cell,
	.van-collapse-item__content {
		background: none;
		padding: 10px 0;
		color: #666666;

	}
</style>
<style scoped>
	#footer {
		/* height: 357px; */
		transition: all ease 0.6s;
		background: #FBFBFB;
		box-sizing: border-box;
		text-align: left;
		color: #666666;
	}


	.footer_top {
		display: flex;
		justify-content: space-between;
		padding: 50px 100px;
		border-bottom: 1px solid #EEEEEE;
	}

	.footer_top_list {
		display: flex;
	}

	.footer_top_list img {
		width: 50px;
		height: 50px;
	}

	.footer_top_list_info {
		margin-left: 20px;
	}

	.footer_top_list_info div {
		font-size: 16px;
		color: #222222;
		margin-bottom: 11px;
	}

	.footer_top_list_info span {
		font-size: 12px;
		color: #666666;
	}


	.company {
		width: 80%;
		margin: 0 auto;
		/* height: 277px; */
		box-sizing: border-box;
		color: #666666;
		display: flex;
		justify-content: space-between;
		/* border-bottom: 1px solid #CCCCCC; */
	}

	.record {
		width: 100%;
		/* height: 80px; */
		box-sizing: border-box;
		background: #FBFBFB;
		padding: 50px 0;
		font-size: 12px;
		border-top: 1px solid #EEEEEE;
		color: #666666;
		/* display: flex; */
		/* justify-content: space-around; */
		text-align: center;
		/* background: red; */
	}



	.gzg_info img {
		width: 80px;
		height: 80px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.gzg_info {
		text-align: center;
		margin-top: 50px;
	}

	.gzg_info p {
		margin: 0;
		font-weight: bold;
		font-size: 20px;
		color: #222;
	}

	.gzg_info div {
		color: #666666;
		font-size: 14px;
		margin-top: 10px;
	}

	.record img {
		width: 36px;
		height: 40px;
		display: inline-block;
	}



	.record span {
		margin-left: 14px;
	}

	.info,
	.info4 {
		margin-top: 50px;

	}

	.info div,
	.info4 div {
		line-height: 30px;
		color: #666666;
		font-size: 14px;
	}

	.info h5,
	.info4 h5 {
		font-weight: 800;
		color: #222222;

	}

	@media screen and (min-width:998px) {
		.company {
			height: 277px;
		}

	}

	.info_list {
		display: none;
	}



	@media screen and (max-width: 997px) {
		.info5 {
			display: none;
		}

		.info_list {
			width: 100%;
			display: inline-block;
		}

		/* 消除折叠面板项的外层边框 */
		::v-deep .van-collapse-item {
			border: none !important;
		}

		/* 消除面板头部的下边框（展开/收起时的分隔线） */
		::v-deep .van-collapse-item__header {
			border-bottom: none !important;
		}

		/* 消除面板内容区的边框（若有） */
		::v-deep .van-collapse-item__content {
			border: none !important;
		}

		/* 可选：消除折叠面板容器的整体边框（如需） */
		::v-deep .van-collapse {
			border: none !important;
		}

		.title {
			font-size: 20px;
		}

		.address_tel_fax {
			font-size: 12px;
		}

		.email_wx {

			font-size: 12px;
		}

		.copy {
			font-size: 12px;
			margin: 30px 0 10px;
		}

		.info {
			display: none;
		}

		.info4 {

			margin-top: 0px;
		}

		.info4 div {
			color: #999;
			font-size: 12px;
		}

		.company {
			width: 90%;
			/* padding-top: 30px; */
			display: inline-block;
			margin-left: 5%;
			border: none;
			/* height: 220px; */
		}

		#footer {
			/* height: 300px; */
		}

		.record span {
			font-size: 10px;
			text-align: left;
			display: inline-block;
			margin-left: 0;
		}


		.gzg_info {
			display: none;
			/* justify-content: space-between; */
			/* border-top: 1px solid #e1e1e1; */
			/* border-bottom: 1px solid #e1e1e1; */
			/* padding: 25px 15px; */
			/* margin-top: 25px; */
		}

		.gzg_info p {
			font-weight: 500;
			font-size: 14px;
			color: #222222;
			line-height: 80px;
		}

		.gzg_info div {
			margin-top: 0;
			font-size: 12px;
		}

		.gzg_info img {
			margin-top: 0;
			width: 60px;
			height: 60px;
			margin-bottom: 10px;
		}

		.footer_top {
			padding: 25px 50px;
			display: inline-block;
		}

		.footer_top_list {
			width: 48%;
			display: inline-block;
			margin: 12px 0;
		}

		.footer_top_list img {
			display: inline-block;
			width: 32px;
			height: 32px;
		}

		.footer_top_list_info {
			display: inline-block;
			margin-left: 10px;

		}

		.footer_top_list_info div {
			font-weight: 500;
			font-size: 12px;
			color: #999999;
		}


		.footer_top_list_info span {
			display: none;
		}


	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue